import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import baseTheme, { CONTRAST_MORE, SCHEME_DARK } from './theme';
var baseColors = baseTheme.colors;
export default _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: _objectSpread(_objectSpread({}, baseTheme.colors), {}, {
    SCHEME: SCHEME_DARK,
    CONTRAST: CONTRAST_MORE,
    bg: baseColors.bgHCDark,
    bgPlaceholder: baseColors.bgPlaceholderHCDark,
    ctrl: baseColors.ctrlHCDark,
    ctrlBg: baseColors.ctrlBgHCDark,
    ctrlDisabled: baseColors.ctrlDisabledHCDark,
    ctrlDisabledLabel: baseColors.ctrlDisabledLabelHCDark,
    ctrlHover: baseColors.ctrlHoverHCDark,
    footerBg: baseColors.footerBgHCDark,
    keyline: baseColors.keylineHCDark,
    label: baseColors.labelHCDark,
    labelCaption: baseColors.labelCaptionHCDark,
    labelPlaceholder: baseColors.labelPlaceholderHCDark,
    labelLegal: baseColors.labelLegalHCDark,
    navBg: baseColors.navBgHCDark,
    navLabel: baseColors.navLabelHCDark,
    navLabelDisabled: baseColors.navLabelDisabledHCDark,
    navLabelHover: baseColors.navLabelHoverHCDark,
    navLabelSelected: baseColors.navLabelSelectedHCDark,
    title: baseColors.titleHCDark,
    badInputBdr: baseColors.badInputBdrHCDark,
    badInputBg: baseColors.badInputBgHCDark,
    badInputLabel: baseColors.badInputLabelHCDark,
    error: baseColors.errorHCDark,
    errorHover: baseColors.errorHoverHCDark,
    errorBdr: baseColors.errorBdrHCDark,
    errorBg: baseColors.errorBgHCDark,
    info: baseColors.infoHCDark,
    infoHover: baseColors.infoHoverHCDark,
    infoBdr: baseColors.infoBdrHCDark,
    infoBg: baseColors.infoBgHCDark,
    success: baseColors.successHCDark,
    successHover: baseColors.successHoverHCDark,
    successBdr: baseColors.successBdrHCDark,
    successBg: baseColors.successBgHCDark,
    warning: baseColors.warningHCDark,
    warningHover: baseColors.warningHoverHCDark,
    warningBdr: baseColors.warningBdrHCDark,
    warningBg: baseColors.warningBgHCDark,
    clrBlue: baseColors.clrBlueHCDark,
    clrGreen: baseColors.clrGreenHCDark,
    clrOrange: baseColors.clrOrangeHCDark,
    clrPurple: baseColors.clrPurpleHCDark,
    clrTeal: baseColors.clrTealHCDark,
    clrGray: baseColors.clrGrayHCDark,
    clrIndigo: baseColors.clrIndigoHCDark,
    clrPink: baseColors.clrPinkHCDark,
    clrRed: baseColors.clrRedHCDark,
    clrYellow: baseColors.clrYellowHCDark,
    appleMusicRed: baseColors.appleMusicRedDark
  })
});